// ♯ and ♭ symbols

// Builds a list of 12 notes with good enharmonic spellings according to key and mode
// (Avoids B#, Cb, E#, Fb) Set key <= 5 for Gb Maj, 6 for F# Maj, 7 for C# Maj.
// F#min (6), C#min (7), & G#min (8) but all others are b's (Db Maj, Eb min, Ab Maj, Bb min, etc.)
// key = 0 - 11, starting note pitch class (C = 0, Db = 1, etc); mode = 0 (Maj) or 1 (min) (to add!! --> or 2 (dim))
// returns a list of note names in chromatic order
function getSpellings(key = 0, quality = 0) {
  // console.log('getSpellings the key and quality are:', key, quality);
  const names = [
    ['C', 'C'],
    ['G', 'G'],
    ['D', 'D'],
    ['A', 'A'],
    ['E', 'E'],
    ['B', 'B'],
    ['F♯', 'G♭'],
    ['C♯', 'D♭'],
    ['G♯', 'A♭'],
    ['D♯', 'E♭'],
    ['A♯', 'B♭'],
    ['F', 'F']
  ];

  // Map chord quality → spelling mode
  // 0 = Major, 1 = Minor, 2 = Dominant, 3 = Diminished, 4 = Augmented, 5 = Altered Dominant
  // major-like: 0,2,4 → 0; minor-like: 1,3,5 → 1
  const mode = quality == 2 || quality == 4 ? 0 : quality == 3 || quality == 5 ? 1 : quality;

  key = (key * 7) % 12;  // circle of 5ths position 0 - 11
  const minor = 6 <= key && key <= 7 && mode === 1 ? 6 : 0;  // key <= 6 & 7 for F#m & C#m, 8 for G#m instead of Abm
  let noteNames = Array(12).fill('');
  for (let i = 0; i < 12; i++) {
    // Force F♯ when dominant or altered dominant (2 or 5),
    // so F♯7 is used rather than G♭7 even if treated as minor-like.
    const note = key <= ((quality === 2 || quality === 5) ? 6 : 5) + minor ? // 5 is Gbmaj7, 6 is F#7
      names[i][i <= 6 + minor + key - mode ? 0 : 1] : // change <= from 6 to 5 for b5 vs #4 in majort mode
      names[i][i <= 7 + minor + key - mode ? 1 : 0]; // changed <= 6 to 7 because sending chordQual for mode (2 is Dominant)
    noteNames[(i * 7) % 12] = note;  // place notes in chromatic order
  }

  return noteNames;
}

function getSpellingsChordQual(key: number = 0, mode: number = 0, chordQual: number = 0) {
  console.log('getSpellings the key, mode and chordQual are:', key, mode, chordQual);
  const names = [
    ['C', 'C'],
    ['G', 'G'],
    ['D', 'D'],
    ['A', 'A'],
    ['E', 'E'],
    ['B', 'B'],
    ['F♯', 'G♭'],
    ['C♯', 'D♭'],
    ['G♯', 'A♭'],
    ['D♯', 'E♭'],
    ['A♯', 'B♭'],
    ['F', 'F']
  ];

  key = (key * 7) % 12;  // circle of 5ths position 0 - 11
  const minor = 6 <= key && key <= 7 && mode === 1 ? 6 : 0;  // key <= 6 & 7 for F#m & C#m, 8 for G#m instead of Abm
  let noteNames = Array(12).fill('');
  for (let i = 0; i < 12; i++) {
    const note = key <= 5 + minor ? // # 5 is Gb Major, 6 is F# Major
      names[i][i <= 6 + minor + key - mode ? 0 : 1] :
      names[i][i <= 7 + minor + key - mode ? 1 : 0]; // changed <= 6 to 7 because sending chordQual for mode (2 is Dominant)
    noteNames[(i * 7) % 12] = note;  // place notes in chromatic order
  }
  return noteNames;
}


function midiToName(midiNote: number, includeOctave: boolean = false, key: number = 0, mode: number = 0) {
  const noteNames = getSpellings(key, mode);
  const noteIdx = midiNote % 12;  // Get note index (+ octave if includeOctave is True)
  const octave = includeOctave ? Math.floor(midiNote / 12) - 1 : "";
  return noteNames[noteIdx] + (includeOctave ? octave.toString() : '');
}


function getSingleSpellings(key = 0, mode = 0) {
  const names = [
    ['c', 'c'],
    ['g', 'g'],
    ['d', 'd'],
    ['a', 'a'],
    ['e', 'e'],
    ['b', 'b'],
    ['f♯', 'g♭'],
    ['c♯', 'd♭'],
    ['g♯', 'a♭'],
    ['d♯', 'e♭'],
    ['a♯', 'b♭'],
    ['f', 'f']
  ];

  key = (key * 7) % 12;  // circle of 5ths position 0 - 11
  const minor = 6 <= key && key <= 7 && mode === 1 ? 6 : 0;  // 6 & 7 are F#m & C#m, 8 is G#m instead of Abm
  let noteNames = Array(12).fill('');
  for (let i = 0; i < 12; i++) {
    const note = key <= 5 + minor ? // # 5 is Gb Major, 6 is F# Major
      names[i][i <= 6 + minor + key - mode ? 0 : 1] :
      names[i][i <= 6 + minor + key - mode ? 1 : 0];
    noteNames[(i * 7) % 12] = note;  // place notes in chromatic order
  }
  return noteNames;
}

function midiToSingleNote(midiNote: number, includeOctave: boolean = false, key: number = 0, mode: number = 0) {
  const noteNames = getSingleSpellings(key, mode);
  const noteIdx = midiNote % 12;  // Get note index (+ octave if includeOctave is True)
  const octave = includeOctave ? Math.floor(midiNote / 12) - 1 : "";
  return noteNames[noteIdx] + (includeOctave ? octave.toString() : '');
}


function velocityToDb(velocity: number): number {
  const lowVelcutoff = 24;

  // Adjust velocities below the cutoff to the cutoff value
  if (velocity <= lowVelcutoff) {
    velocity = lowVelcutoff;
  }

  return 40 * logBase(10, velocity / 127) - 6;
}

function logBase(base: number, number: number): number {
  return Math.log(number) / Math.log(base);
}

function midiToScaleDegree(midiNote: number, rootNote: number, mode: number): string {

  const scaleDegreeNames = [
    ['R', 'R'],    // 0
    ['m2', 'm2'],  // 1
    ['M2', 'M2'],    // 2
    ['m3', 'm3'],  // 3
    ['M3', 'M3'],    // 4
    ['P4', 'P4'],    // 5
    ['A4', 'd5'],  // 6
    ['P5', 'P5'],    // 7
    ['m6', 'm6'],  // 8
    ['M6', 'M6'],    // 9
    ['D7', 'm7'],  // 10
    ['M7', 'M7'],    // 11
  ];

  const pitchClass = midiNote % 12;
  const interval = (pitchClass - rootNote + 12) % 12; // Calculate interval from root
  return scaleDegreeNames[interval][mode];
}

function midiToScaleDegreeNumber(midiNote: number, rootNote: number, quality: number): string {

  const scaleDegreeNumbers = [
    ['R', 'R'],    // 0
    ['♭2', '♭2'],  // 1
    ['2', '2'],    // 2
    ['♭3', '♭3'],  // 3
    ['3', '3'],    // 4
    ['4', '4'],    // 5
    ['♯4', '♭5'],  // 6
    ['5', '5'],    // 7
    ['♭6', '♭6'],  // 8
    ['6', '6'],    // 9
    ['♭7', '♭7'],  // 10
    ['7', '7'],    // 11
  ];

  // Map chord quality → spelling mode
  // 0 = Major, 1 = Minor, 2 = Dominant, 3 = Diminished, 4 = Augmented, 5 = Altered Dominant
  // major-like: 0,2,4 → 0; minor-like: 1,3,5 → 1
  const mode = quality == 2 || quality == 4 ? 0 : quality == 3 || quality == 5 ? 1 : quality;

  const pitchClass = midiNote % 12;
  const interval = (pitchClass - rootNote + 12) % 12; // Calculate interval from root
  return scaleDegreeNumbers[interval][mode];
}

function midiToScaleDegreeExtension(midiNote: number, rootNote: number, quality: number): string {

  const scaleDegreeExtensions = [
    ['R', 'R'],    // 0
    ['♭9', '♭9'],  // 1
    ['9', '9'],    // 2
    ['♭3', '♭3'],  // 3
    ['3', '3'],    // 4
    ['11', '11'],    // 5
    ['♯11', '♭5'],  // 6
    ['5', '5'],    // 7
    ['♭13', '♭13'],  // 8
    ['13', '13'],    // 9
    ['♭7', '♭7'],  // 10
    ['7', '7'],    // 11
  ];

  // Map chord quality → spelling mode
  // 0 = Major, 1 = Minor, 2 = Dominant, 3 = Diminished, 4 = Augmented, 5 = Altered Dominant
  // major-like: 0,2,4 → 0; minor-like: 1,3,5 → 1
  const mode = quality == 2 || quality == 4 ? 0 : quality == 3 || quality == 5 ? 1 : quality;

  const pitchClass = midiNote % 12;
  const interval = (pitchClass - rootNote + 12) % 12; // Calculate interval from root
  return scaleDegreeExtensions[interval][mode];
}

function midiToRomanNumeral(midiNote: number, rootPc: number, keyMode: number, chordQual: number): string {

  const chordMode = chordQual == 2 || chordQual == 4 || chordQual == 5 ? 0 : chordQual == 3 ? 1 : chordQual;

  const romanNumerals = [
    ['I', 'i'],    // 0
    ['♭II', '♭ii'],  // 1
    ['II', 'ii'],    // 2
    ['♭III', '♭iii'],  // 3
    ['III', 'iii'],    // 4
    ['IV', 'iv'],    // 5
    [keyMode == 0 ? '♯IV' : '♭V', keyMode == 0 ? '♯iv' : '♭v'],  // 6
    ['V', 'v'],    // 7
    ['♭VI', '♭vi'],  // 8
    ['VI', 'vi'],    // 9
    ['♭VII', '♭vii'],  // 10
    ['VII', 'vii'],    // 11
  ];

  const interval = (midiNote - rootPc + 12) % 12; // Calculate interval from root
  const seventhChord = ''
  // const seventhChord = chordQual == 2 ? '7' : chordQual == 3 ? '°' : chordQual == 4 ? '+' : ''; // optionally add '7' to seventh chords
  return romanNumerals[interval][chordMode] // + seventhChord;
}

function midiToNashvilleNumber(midiNote: number, rootPc: number, keyMode: number, chordQual: number): string {

  const chordMode = chordQual == 2 || chordQual == 4 || chordQual == 5 ? 0 : chordQual == 3 ? 1 : chordQual;

  const nashvilleNumbers = [
    ['1', '1'],    // 0
    ['♭2', '♭2'],  // 1
    ['2', '2'],    // 2
    ['♭3', '♭3'],  // 3
    ['3', '3'],    // 4
    ['4', '4'],    // 5
    [keyMode == 0 ? '♯4' : '♭5', keyMode == 0 ? '♯4' : '♭5'],  // 6
    ['5', '5'],    // 7
    ['♭6', '♭6'],  // 8
    ['6', '6'],    // 9
    ['♭7', '♭7'],  // 10
    ['7', '7'],    // 11
  ];

  const interval = (midiNote - rootPc + 12) % 12; // Calculate interval from root
  return nashvilleNumbers[interval][chordMode] // + seventhChord;
}

// midiBassToName is unused
function midiBassToName(bassPC: number, rootName: string, mode: number): string {
  // Get note names using bassPC as key context
  const noteNames = getSpellings(bassPC, mode);

  // If root uses sharp and bass is flat (or vice versa), get alternate spelling
  if ((rootName.includes('♯') && noteNames[bassPC].includes('♭')) ||
    (rootName.includes('♭') && noteNames[bassPC].includes('♯'))) {
    const altSpellings = getSpellings((bassPC + 6) % 12, mode);
    return altSpellings[bassPC];
  }

  return noteNames[bassPC];
}

// Overtone configuration
const OVERTONE_RANGES = {
  HIGHEST: { min: 65, max: 85 },  // Eb4 to Db6 (def 65-85 C4 to Db6) changed to 65-85
  HIGH: { min: 56, max: 64 },     // Ab3 to E4 (def 47-59 B2 to B3) changed to 56-64
  MID: { min: 38, max: 55 },      // D2 to G3 (def 38-46 D2 to Bb2) changed to 38-55
  LOW: { min: 28, max: 37 },      // D1 to Db2
  LOWEST: { min: 21, max: 27 }    // A0 to Db1
};

const OVERTONES = {
  OVERTONE_1_OCTAVE: { interval: 12, opacity: 0.50 },
  OVERTONE_2_FIFTH: { interval: 19, opacity: 0.33 },
  OVERTONE_3_2nd_OCTAVE: { interval: 24, opacity: 0.25 },
  OVERTONE_4_MAJ_3rd: { interval: 28, opacity: 0.20 },
  OVERTONE_5_2nd_FIFTH: { interval: 31, opacity: 0.16 }
};

// Map of which overtones are available for each range
const RANGE_OVERTONES = {
  HIGHEST: [OVERTONES.OVERTONE_1_OCTAVE],
  HIGH: [OVERTONES.OVERTONE_1_OCTAVE, OVERTONES.OVERTONE_2_FIFTH],
  MID: [OVERTONES.OVERTONE_1_OCTAVE, OVERTONES.OVERTONE_2_FIFTH, OVERTONES.OVERTONE_3_2nd_OCTAVE],
  LOW: [OVERTONES.OVERTONE_1_OCTAVE, OVERTONES.OVERTONE_2_FIFTH, OVERTONES.OVERTONE_3_2nd_OCTAVE, OVERTONES.OVERTONE_4_MAJ_3rd],
  LOWEST: Object.values(OVERTONES)
};

function getOvertoneInfo(note: number, primaryNotes: number[]): number | false {
  if (note < 33 || note > 116) return false;

  const uniquePrimaryNotes = [...new Set(primaryNotes)];

  let overtoneStrengths: number[] = [];

  // For any active note that this note is an overtone of,
  // accumulate the opacities
  for (const primaryNote of uniquePrimaryNotes) {
    if (primaryNote >= 86 || primaryNote >= note) continue;

    const interval = note - primaryNote;

    // Find which range the active note falls into
    let range: keyof typeof RANGE_OVERTONES | undefined;
    for (const [rangeName, rangeValues] of Object.entries(OVERTONE_RANGES)) {
      if (primaryNote >= rangeValues.min && primaryNote <= rangeValues.max) {
        range = rangeName as keyof typeof RANGE_OVERTONES;
        break;
      }
    }

    if (!range) continue;

    // Find the exact overtone relationship and add its opacity to total
    const overtone = RANGE_OVERTONES[range].find(o => o.interval === interval);
    if (overtone) {
      overtoneStrengths.push(overtone.opacity);
    }
  }

  if (overtoneStrengths.length === 0) return false;

  // Sort strengths in descending order
  overtoneStrengths.sort((a, b) => b - a);

  // Logarithmic combination with reinforcement factor
  const combinedStrength = 1 - Math.exp(-overtoneStrengths.reduce((acc, strength) => {
    return acc + Math.log(1 + strength);
  }, 0));

  return Math.min(combinedStrength, 1);
}

function getOvertoneNotes(primaryNotes: number[]): number[] {
  const overtoneNotes: number[] = [];

  // Check all possible MIDI notes for overtone relationships
  for (let note = 33; note <= 116; note++) {
    const overtoneStrength = getOvertoneInfo(note, primaryNotes);
    if (overtoneStrength !== false) {
      overtoneNotes.push(note);
    }
  }

  return overtoneNotes;
}

function getModeFromPcSet(pcs: number[] | undefined): number {
  if (!pcs || pcs.length === 0) return 0;
  const hasMajorThird: boolean = pcs.includes(4);
  const hasMinorThird: boolean = pcs.includes(3);

  if (hasMajorThird) {
    return 0; // Major 3rd is Major mode
  } else if (hasMinorThird) {
    return 1; // Minor 3rd with no Major 3rd is Minor mode
  } else {
    return 0; // Use Major mode when no 3rd is present
  }
}

function getQualityFromPcSet(pcs: number[]): number {
  const hasMajorThird: boolean = pcs.includes(4);
  const hasMinorThird: boolean = pcs.includes(3);

  // Python script example to use for quality determination
  // # Get Mode
  // minmaj = 0
  // if min_str in tq or dim_str in tq or "sus(" + flat_str + "5)" in cs:
  //     minmaj = 1
  // elif 4 not in third and (8 in fifth or 1 in second): # and 2 not in second:
  //     # if 9 in seventh or 11 in seventh or 2 in second or 1 in second or 4 in third:
  //     minmaj = 0 if (1 in second and 8 not in fifth and 10 in seventh) else 1  # Initialize minmaj to 1
  //     if 8 in fifth:
  //         for x in [2, 9, 11]:
  //             if x in c and c_midi[c.index(x)] < c_midi[c.index(8)]: # check if b6 is voiced lower than other Maj influencing pitches
  //                 minmaj = 0
  //                 break
  // elif 4 not in third and 6 in fifth:
  //     if 2 not in second and 7 not in fifth:
  //         if c_midi[c.index(6)] < c_midi[c.index(0)]:
  //             minmaj = 1
  // # elif 8 in fifth and 9 not in seventh and 11 not in seventh and 2 not in second and 1 not in second and 4 not in third:
  // # elif set([8]) <= fifth and not set([9, 11, 2, 1, 4]) & set([seventh, second, third]):
  //     # print("YES", fifth, seventh)
  //     # minmaj = 1
  // # elif fifth == [6, 8]:
  // #     minmaj = 1
  // else:
  //     minmaj = 0

  // # Get Chord Quality
  // if minmaj == 1:
  //     if dim_str in tq or (min_str in tq and flat_str + "5" in sq):
  //         chord_qual = 3 # Diminished
  //     else:
  //         chord_qual = 1 # Minor
  // elif 10 in seventh or (10 not in seventh and 11 not in seventh and 4 in third and (3 in third or 1 in second)):
  //     if "alt" in cs or (3 in third and 2 not in second and 7 not in fifth and 9 not in seventh) or (6 in fifth and 7 not in fifth and 9 not in seventh and (3 in third or 1 in second or 8 in fifth)):
  //         chord_qual = 5 # Altered Dominant, new addition
  //     else:
  //         chord_qual = 2 # Dominant
  // elif 10 not in seventh and 7 not in fifth and 8 in fifth:
  //     chord_qual = 4 # Augmented
  // else:
  //     chord_qual = 0 # Major

  if (hasMajorThird) {
    return 0; // Major 3rd is Major mode
  } else if (hasMinorThird) {
    return 1; // Minor 3rd with no Major 3rd is Minor mode
  } else {
    return 0; // Use Major mode when no 3rd is present
  }
}


// iRealPro chords
// 5, 2, add9, add2, +, o, h, sus, sus2, sus4, ^, -, ^7, -7, 7, 7sus, h7, o7, ^9, ^13, 6, 69,
// ^7#11, ^9#11, ^13#11, ^7#5, -6, -69, -^7, -^9, -9, -11, -7b5, h9, -b6, -#5, 9, 7b9, 7#9, 7#11, 7b5,
// 7#5, 9#11, 9b5, 9#5, 7b13, 7#9#5, 7#9b5, 7#9#11, 7b9#11, 7b9b5, 7b9#5, 7b9#9, 7b9b13, 7alt,
// 13, 13#11, 13b9, 13#9, 7b9sus, 7susadd3, 9sus, 13sus, 7b13sus, 11, min13, min^11, min^13,
// maj13#11, maj7b5, maj7#9, min7b6, min9b6, maj(add4), min(add4), 7(add13)



// min9b6

// List of approved chords (all relative to root = 0)
const iRealProChords: number[][] = [
  [0, 7], // 5
  [0, 4], [0, 4, 7], // (Major)
  [0, 2, 4], [0, 2, 4, 7], // add2
  [0, 2], [0, 2, 7], // sus2
  [0, 4, 5], [0, 4, 5, 7], // add4
  [0, 5], [0, 5, 7], // sus4
  [0, 4, 9], [0, 4, 7, 9], // 6
  [0, 4, 9, 2], [0, 4, 7, 9, 2], // 69
  [0, 4, 11], [0, 4, 7, 11], // ∆7
  [0, 4, 11, 2], [0, 4, 7, 11, 2], // ∆9
  [0, 4, 11, 9], [0, 4, 7, 11, 9], [0, 4, 11, 9, 2], [0, 4, 7, 11, 9, 2], // ∆13
  [0, 4, 11, 6], [0, 4, 7, 11, 6], // ∆7#11
  [0, 4, 11, 2, 6], [0, 4, 7, 11, 2, 6], // ∆9#11
  [0, 4, 11, 9, 6], [0, 4, 7, 11, 9, 6], [0, 4, 11, 9, 6, 2], [0, 4, 7, 11, 9, 2, 6], // ∆13#11
  [0, 4, 8, 11], // ∆7#5
  [0, 4, 3, 11], [0, 4, 3, 7, 11], // ∆7#9
  [0, 4, 10], [0, 4, 7, 10], // 7 (Dominant)
  [0, 5, 10], [0, 5, 7, 10], // 7sus
  [0, 4, 5, 10], [0, 4, 5, 7, 10], // 7add4 (in iRealPro as 7susadd3 or 11)
  [0, 4, 10, 2], [0, 4, 7, 10, 2], // 9
  [0, 5, 10, 2], [0, 5, 7, 10, 2], // 9sus
  [0, 4, 5, 10, 2], [0, 4, 5, 7, 10, 2], // 9add4 (in iRealPro as 11)
  [0, 4, 10, 9], [0, 4, 7, 10, 9], [0, 4, 10, 9, 2], [0, 4, 7, 10, 9, 2], // 13
  [0, 5, 10, 9], [0, 5, 7, 10, 9], [0, 5, 10, 9, 2], [0, 5, 7, 10, 9, 2], // 13sus
  [0, 4, 5, 10, 9], [0, 4, 5, 7, 10, 9], [0, 4, 5, 10, 9, 2], [0, 4, 5, 7, 10, 9, 2], // 13add4 (not in iRealPro)
  [0, 4, 10, 1], [0, 4, 7, 10, 1], // 7b9
  [0, 5, 10, 1], [0, 4, 7, 10, 1], // 7b9sus
  [0, 4, 10, 3], [0, 4, 7, 10, 3], // 7#9
  [0, 4, 10, 6], [0, 4, 7, 10, 6], // 7#11
  [0, 4, 6, 10, 2], [0, 4, 6, 7, 10, 2], // 9#11
  [0, 4, 6, 10, 9], [0, 4, 6, 7, 10, 9], [0, 4, 6, 10, 9, 2], [0, 4, 6, 7, 10, 9, 2], // 13#11
  [0, 4, 10, 9, 1], [0, 4, 7, 10, 9, 1], // 13b9
  [0, 4, 10, 9, 3], [0, 4, 7, 10, 9, 3], // 13#9
  [0, 4, 8, 10], // 7#5
  [0, 4, 8, 10, 2], // 9#5
  [0, 4, 7, 8, 10], // 7b13
  [0, 5, 8, 10], [0, 5, 7, 8, 10], // 7b13sus
  [0, 4, 8, 10, 3], [0, 4, 6, 8, 10, 3], [0, 4, 6, 10, 1, 3], [0, 4, 8, 10, 1, 3], [0, 4, 6, 8, 10, 3], [0, 4, 6, 8, 10, 1, 3], // ALT, 7#9#5
  [0, 4, 6, 10, 3], // 7#9b5
  [0, 4, 6, 7, 10, 3], // 7#9#11
  // [0, 4, 6, 10, 3], // 7#9b9 (not in iRealPro)
  [0, 4, 6, 7, 10, 1], // 7b9#11
  [0, 4, 6, 10, 1], // 7b9b5
  [0, 4, 8, 10, 1], // 7b9#5
  [0, 4, 10, 1, 3], [0, 4, 7, 10, 1, 3], // 7b9#9
  [0, 4, 7, 8, 10, 1], // 7b9b13
  [0, 3], [0, 3, 7], // m (Minor)
  [0, 2, 3], [0, 2, 3, 7], // madd2
  [0, 3, 5], [0, 3, 5, 7], // madd4
  [0, 3, 9], [0, 3, 7, 9], // m6
  [0, 3, 9, 2], [0, 3, 7, 9, 2], // m69
  [0, 3, 8], [0, 3, 7, 8], // mb6
  [0, 3, 10], [0, 3, 7, 10], // m7
  [0, 3, 10, 2], [0, 3, 7, 10, 2], // m9
  [0, 3, 10, 5], [0, 3, 7, 10, 5], [0, 3, 10, 5, 2], [0, 3, 7, 10, 5, 2], // m11
  [0, 3, 10, 9], [0, 3, 7, 10, 9], [0, 3, 10, 9, 2], [0, 3, 7, 10, 9, 2], [0, 3, 10, 9, 5], // m13
  [0, 3, 7, 10, 9, 5], [0, 3, 10, 9, 5, 2], [0, 3, 7, 10, 9, 5, 2], // m13 continued
  [0, 3, 8, 10], [0, 3, 7, 8, 10], // m7b13
  [0, 3, 8, 10, 2], [0, 3, 7, 8, 10, 2], // m9b13
  [0, 3, 6, 10], [0, 3, 7, 10], // m7b5
  [0, 3, 6, 10, 2], // m9b5
  [0, 3, 11], [0, 3, 7, 11], // m∆7
  [0, 3, 11, 2], [0, 3, 7, 11, 2], // m∆9
  [0, 3, 11, 5], [0, 3, 7, 11, 5], [0, 3, 11, 5, 2], [0, 3, 7, 11, 5, 2], // m∆11
  [0, 3, 11, 9], [0, 3, 7, 11, 9], [0, 3, 11, 9, 2], [0, 3, 7, 11, 9, 2], [0, 3, 11, 9, 5], // m∆13
  [0, 3, 7, 11, 9, 5], [0, 3, 11, 9, 5, 2], [0, 3, 7, 11, 9, 5, 2], // m∆13 continued
  [0, 3, 6], // ° (Diminished)
  [0, 3, 6, 9], // °7
  [0, 3, 6, 10], // m7b5
  [0, 4, 8], // + (Augmented)
  // [0, 4, 3,] // (add#9) (not in iRealPro)
];

const approvedChordsSorted = iRealProChords.map(c => JSON.stringify([...c].sort((a, b) => a - b)));
const isSubscribed = true; // TODO: replace with actual subscription check
// function isApprovedChords(pcs: number[]) {
function checkApprovedChord(pcs: number[], rootPc: number): boolean {
  if (isSubscribed) return true; // comment out to include subscription check
  
  // Transpose pcs relative to root (transpose so root = 0), remove duplicates (set), and sort
  const normalizedPcs = [...new Set(pcs.map(pc => (pc - rootPc + 12) % 12))].sort((a, b) => a - b);
  const normalizedStr = JSON.stringify(normalizedPcs);
  // return iRealProChords.includes(pcs);
  // return iRealProChords.some(chord => JSON.stringify(chord) === normalizedStr);
  return approvedChordsSorted.includes(normalizedStr);
}


export { getSpellings, midiToName, midiToSingleNote, midiBassToName, midiToScaleDegree, midiToRomanNumeral, midiToNashvilleNumber, midiToScaleDegreeNumber, midiToScaleDegreeExtension, velocityToDb, getOvertoneInfo, getOvertoneNotes, getModeFromPcSet, checkApprovedChord };
